import { ILGEDocument } from "../interfaces/ILGEDocument";


export class LGDocument {
    private readonly _lgeDocument: ILGEDocument | null;
  
    constructor(
        lgeDocument: ILGEDocument | null
    ) {
      this._lgeDocument = lgeDocument;
    }

    get uid(): string {
        return this._lgeDocument?.uid ?? '';
    }   

    get documentType(): string {
        return this._lgeDocument?.documentType ?? '';
    } 

    get fileType(): string {
        return this._lgeDocument?.fileType ?? '';
    }

    get documentDescription(): string {
        return this._lgeDocument?.documentDescription ?? '';
    }

    get documentUrl(): string {
        return this._lgeDocument?.documentUrl ?? '';
    }

    get createdOn(): Date {
        return this._lgeDocument?.createdOn ?? new Date();
    }


}